/* PGPersonalInformation.js
   PG-only wrapper around the existing PersonalInformation component.
   Adds Military Service Status for Egyptian male applicants only.
   The base PersonalInformation component is NOT modified.
*/
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PersonalInformation from './PersonalInformation'
import InputRow from './InputRow'

const MILITARY_STATUS_OPTIONS = [
  { Id: 'Completed', value: 'Completed' },
  { Id: 'Exempt', value: 'Exempt' },
  { Id: 'Postponed', value: 'Postponed' },
  { Id: 'Not Applicable', value: 'Not Applicable' }
]

export default class PGPersonalInformation extends Component {
  constructor (props) {
    super(props)
    this.state = {
      militaryStatus: props.militaryStatus || ''
    }
  }

  /* Receive gender/nationality changes from the base PI component via collectState */
  handleCollectState (data) {
    this.props.collectState('PI', data)
    /* When gender or nationality changes, we may need to clear military status
       if the applicant is no longer Egyptian male */
    const isEgyptianMale =
      parseInt(data.selectedNationality) === 50 && data.selectedGender === 'Male'
    if (!isEgyptianMale && this.state.militaryStatus) {
      this.setState({ militaryStatus: '' })
      this.props.collectState('PG_Military', '')
    }
  }

  isEgyptianMale () {
    const data = this.props.data || {}
    const nat = parseInt(data.selectedNationality || this.props.nationality)
    const gender = data.selectedGender || this.props.gender
    return nat === 50 && gender === 'Male'
  }

  render () {
    const { militaryStatus } = this.state
    const { error, errorMilitary } = this.props
    const showMilitary = this.isEgyptianMale()

    return (
      <div>
        {/* Render the unmodified base PersonalInformation component */}
        <PersonalInformation
          countryData={this.props.countryData}
          dateOfBirth={this.props.dateOfBirth}
          countryOfBirth={this.props.countryOfBirth}
          nationality={this.props.nationality}
          gender={this.props.gender}
          arabicData={this.props.arabicData}
          siblingFName={this.props.siblingFName}
          siblingMName={this.props.siblingMName}
          siblingLName={this.props.siblingLName}
          siblingTKHNumber={this.props.siblingTKHNumber}
          incompleteApplicationId={this.props.incompleteApplicationId}
          fName={this.props.fName}
          lName={this.props.lName}
          mName={this.props.mName}
          error={error}
          onSave={this.props.onSave}
          collectState={(name, data) => this.handleCollectState(data)}
          hideNextButton={true}
        />

        {/* Military Service Status — Egyptian males only */}
        {showMilitary && (
          <div style={{ marginTop: 10 }}>
            <p style={{ fontWeight: 'bold', marginBottom: 4 }}>
              Military Service Status
            </p>
            <p style={{ fontSize: 12, color: '#555', marginBottom: 6 }}>
              Applicable for Egyptian male applicants only.
            </p>
            <InputRow
              rowName='Military Service Status'
              name='select'
              value={militaryStatus}
              data={MILITARY_STATUS_OPTIONS}
              required='*'
              errMsg={errorMilitary || ''}
              onChange={(val) => {
                this.setState({ militaryStatus: val })
                this.props.collectState('PG_Military', val)
              }}
            />
          </div>
        )}

        <button className="save" onClick={() => { this.props.onSave() }}>Next</button>
      </div>
    )
  }
}

PGPersonalInformation.propTypes = {
  fName: PropTypes.string.isRequired,
  lName: PropTypes.string.isRequired,
  mName: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  countryData: PropTypes.array.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  gender: PropTypes.string,
  countryOfBirth: PropTypes.number,
  nationality: PropTypes.number,
  arabicData: PropTypes.array,
  dateOfBirth: PropTypes.string,
  error: PropTypes.object,
  errorMilitary: PropTypes.string,
  collectState: PropTypes.func,
  militaryStatus: PropTypes.string,
  siblingFName: PropTypes.string,
  siblingMName: PropTypes.string,
  siblingLName: PropTypes.string,
  siblingTKHNumber: PropTypes.string
}
